module.exports = __webpack_public_path__ + "static/media/رحلات متعددة الى جبال الالب الشهيرة.d98999a6.jpeg";